import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubTabBar } from './SubTabBar';
import CreatorsList from './CreatorsList';
import CreatorsDiscovery from './CreatorsDiscovery';

/** The tracked creator DATABASE (all scraped handles, ~thousands) — NOT accounts.
 *  Roster = clean sortable list; Discovery = the full scrape-ops / suggested / delete tool. */
export default function CreatorsCatalog() {
  const { t } = useTranslation('admin');
  const [tab, setTab] = useState<'roster' | 'discovery'>('roster');
  return (
    <>
      <h2 style={{ margin: '0 0 16px' }}>{t('cat.title', { defaultValue: 'Каталог креаторов' })}</h2>
      <SubTabBar active={tab} onChange={(v) => setTab(v as 'roster' | 'discovery')} tabs={[
        { v: 'roster', label: t('cat.roster', { defaultValue: 'Ростер' }) as string },
        { v: 'discovery', label: t('cr.discovery', { defaultValue: 'Discovery / скрейп' }) as string },
      ]} />
      {tab === 'roster' ? <CreatorsList /> : <CreatorsDiscovery />}
    </>
  );
}
